export default "__VITE_ASSET__a6b4a51d__"